module.exports = __webpack_public_path__ + "static/mevia-extraimg3@2x-min-6b2d26cce78ccb5eb0e6f616860a6bb0.png";